import { format } from "date-fns";
import { nextDate, startEndDate } from "../../../utils/EventoUtils";
import { Status } from "../../../utils/Status";
import { VerifyPermits } from "../../../utils/Permisos";

const Cupon = ({ data, onClick, navigate, user }) => {
  return (
    <tr>
      <td className="Grifter d-none d-md-table-cell">#{data.id}</td>
      <td className="Grifter fs-6">
        {data.nombre}
      </td>
      <td>{data.codigo}</td>
      <td>{data.descuento}</td>
      <td className="d-none d-md-table-cell">{data.limite}</td>
      <td className="d-none d-md-table-cell">{data.fecha_habilitacion}</td>
      <td className="d-none d-md-table-cell">{data.fecha_expiracion}</td>
      <td className="d-none d-md-table-cell">
        <div class="dropdown">
          <button
            class="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
            style={{ borderRadius: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {data.status}
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <label className="btn m-0 p-0">
                <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                Activar
                <button
                  className="d-none"
                  name="status-cupon"
                  onClick={(event) =>
                    onClick(event, { cupon: data, status: 'ACTIVO' })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
                <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                Pausar
                <button
                  className="d-none"
                  name="status-cupon"
                  onClick={(event) =>
                    onClick(event, { cupon: data, status: 'INACTIVO' })
                  }
                ></button>
              </label>
            </li>

            <li>
              <label className="btn m-0 p-0 d-none">
                <i class="text-danger mx-1 bi bi-trash"></i>
                Eliminar
                <button
                  className="d-none"
                  name="status-cupon"
                  onClick={(event) =>
                    onClick(event, { cupon: data, status: 'ELIMINADO' })
                  }
                ></button>
              </label>
            </li>
          </ul>
        </div>
      </td>
                  
      <td className="d-none d-md-table-cell">{data.tipo_aplicacion}</td>
      <td>
        <label
          className={`btn btn-success me-1 mb-1`}
        >
          <i class="bi bi-pencil-square"></i>
          <button
            className="d-none"
            name="editar-cupon"
            onClick={(e) => onClick(e, data.id)}
          ></button>
        </label>
        <label
          className={`btn btn-primary me-1 mb-1`}
        >
          <i class="bi bi-download"></i>
          <button
            className="d-none"
            name="download-usos"
            onClick={(e) => onClick(e, data.id)}
          ></button>
        </label>
      </td>
    </tr>
  );
};

export default Cupon;
